import { ErrorSettingsHelper } from '../errors/settings'
import { ModeSettingsHelper } from '../settings'

export class VasSettingsHelper extends ModeSettingsHelper {
  constructor(settings, modal) {
    super(settings)

    this.addIdsToSchemas(this._settings)

    if (this.isModeSettingProcessable('required')) {
      this._errors = new ErrorSettingsHelper(
        this._settings.required.error_settings,
        modal
      )
    }
  }

  isIncompatible(actualVas, selectedSet) {
    if (!selectedSet || !selectedSet.length) {
      return false
    }

    if (selectedSet.map(vas => vas.id_vas).includes(actualVas.id_vas)) {
      return false
    }

    return selectedSet.map(vas => vas.id_dominio).includes(actualVas.id_dominio)
  }
}
